import React, { FC, PropsWithChildren, useMemo } from 'react';
import styles from './CvTemplate.module.less';
import { TextBlock } from '../../uicomp/atmos/content-block/ContentBlock';
import { TemplateSelectBox } from './TemplateSelectBox';
import { CvTemplateData, TEMPLATES } from './CvTemplateModal';

type Props = {
  selectedTemplateTitle?: string;
  onChangeTemplate?: (value: CvTemplateData) => void;
  profileImage?: string;
};
// import dynamic from 'next/dynamic';
// const PDFViewer = dynamic(() => import('./templates/Template1'), {
//   ssr: false,
// });
export const CvTemplatePageLayout: FC<PropsWithChildren<Props>> = (props) => {
  const getTemplates = useMemo(() => {
    const url = props.profileImage;
    if (url) {
      const name = url.substring(url.lastIndexOf('/') + 1);
      if (name === 'user.png') {
        return TEMPLATES.filter((t) => t.image !== true);
      }
    }
    return TEMPLATES;
  }, [props.profileImage]);
  return (
    <div style={{ display: 'flex' }}>
      <div className={styles.leftCol}>
        <div className={styles.leftColBody}>
          <TextBlock heading strong>
            Templates
          </TextBlock>
          {getTemplates.map((item, index) => (
            <TemplateSelectBox
              onClick={() => {
                props.onChangeTemplate?.(item);
              }}
              selected={item.title === props.selectedTemplateTitle}
              key={index}
              title={item.title}
            />
          ))}
        </div>
      </div>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
};
